import ReducerEntityPrefixTypes from "../../../../../enums/reducer/reducerEntityPrefixTypes";
import ReducerNamespaceTypes from "../../../../../enums/reducer/reducerNamespaceTypes";
import { type RootState } from "../../../../Application/globaltypes/redux";
import { createSearchSlice, type SearchState } from "../../../../Application/slices/createSearchSlice";

export const initialState: SearchState = {
  term: undefined,
};

const accountPacksSearchSlice = createSearchSlice({
  namePayload: {
    namespace: ReducerNamespaceTypes.Licensing,
    entity: ReducerEntityPrefixTypes.AccountPacks,
    name: "search",
  },
  initialState,
  reducers: {},
});

export const setAccountPacksSearchTerm = accountPacksSearchSlice.actions.setTerm;

export const accountPacksSearchSelector = (state: RootState) => state.packs.accountPacksSearch;

export default accountPacksSearchSlice.reducer;
